import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import { Button, Flex, Box, Copy } from '@elparking/components'

import messages from './messages'
import FilterButton from './FilterButton'
import { SPEED_CHARGING_FAST, SPEED_CHARGING_FAST_DESCRIPTION, SPEED_CHARGING_SEMIFAST, SPEED_CHARGING_SEMIFAST_DESCRIPTION, SPEED_CHARGING_SLOW, SPEED_CHARGING_SLOW_DESCRIPTION } from 'commons/js/constants'

const makeIsSpeedTypeFilterEnabled = (speedType) => (filters) => filters && filters[speedType]
const makeUpdateSpeedTypeFilter = (speedType) => (filters) => ({
    ...filters,
    [speedType.value]: !filters[speedType.value],
})

export const chargingPointSpeedTypes = [
    {
        text: messages.slow,
        powerRangeText: '< 7kW',
        value: SPEED_CHARGING_SLOW_DESCRIPTION,
        icon: null,
        isEnabled: makeIsSpeedTypeFilterEnabled(SPEED_CHARGING_SLOW_DESCRIPTION),
        speedCategory: SPEED_CHARGING_SLOW,
    },
    {
        text: messages.semiFast,
        powerRangeText: '7kW-22kW',
        value: SPEED_CHARGING_SEMIFAST_DESCRIPTION,
        icon: '/images/electric-charge/semifast_charge_icon.webp',
        isEnabled: makeIsSpeedTypeFilterEnabled(SPEED_CHARGING_SEMIFAST_DESCRIPTION),
        speedCategory: SPEED_CHARGING_SEMIFAST,
    },
    {
        text: messages.fast,
        powerRangeText: '+22kW',
        value: SPEED_CHARGING_FAST_DESCRIPTION,
        icon: '/images/electric-charge/fast_charge_icon.webp',
        isEnabled: makeIsSpeedTypeFilterEnabled(SPEED_CHARGING_FAST_DESCRIPTION),
        speedCategory: SPEED_CHARGING_FAST,
    },
]

function ChargingPointSpeedFilters ({
    filters: initialFilters,
    setFilters,
}) {
    const intl = useIntl()
    const [filters, setDraftFilters] = useState(initialFilters)

    return (
        <Flex w='100%' flexWrap='wrap' px='1em'>
            <Box mb='2em'>
                <Copy padding='0' fontSize='xxLarge' fontWeight='medium' color='gray'>
                    <FormattedMessage defaultMessage='Tipo de carga' />
                </Copy>
            </Box>
            <Box w='100%' mb='1em'>
                {chargingPointSpeedTypes.map((speedType, index) => (
                    <Box w='100%' mb='1em' key={index}>
                        <FilterButton
                          dataTest={`filter-button-${speedType.value}`}
                          width='100%'
                          padding='1em'
                          selected={speedType.isEnabled(filters)}
                          onClick={() => {
                              setDraftFilters(makeUpdateSpeedTypeFilter(speedType))
                          }}
                        >
                            <Flex justifyContent='center' alignItems='center'>
                                {speedType.icon && <img src={speedType.icon} />}
                                <Copy as='span' padding={speedType.icon ? '0 0 0 8px' : '0'} color='inherit' fontSize='small'>{intl.formatMessage(speedType.text)}</Copy>
                                <Copy as='span' padding='0 0 0 1em' color='inherit' fontWeight='regular' fontSize='medium' textTransform='uppercase'>{speedType.powerRangeText}</Copy>
                            </Flex>
                        </FilterButton>
                    </Box>
                ))}
            </Box>
            <Flex w='100%' justifyContent='space-between' alignItems='center'>
                <Box flex='1 1 auto'>
                    <Button.unstyled dataTest='cancel-filters-button' width='100%' color='gray60' onClick={() => { setFilters(initialFilters) }}>Cancelar</Button.unstyled>
                </Box>
                <Flex flex='1 0 auto'>
                    <Button width='100%' dataTest='apply-filters-button' height='auto' onClick={() => { setFilters(filters) }}>Aplicar filtros</Button>
                </Flex>
            </Flex>
        </Flex>
    )
}

ChargingPointSpeedFilters.propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
}

export default ChargingPointSpeedFilters
